import { useEffect, useState } from "react";

const useContraste = () => {
  const [isContraste, setIsContraste] = useState(false);

  useEffect(() => {
    // Aplica a classe do contraste se estiver salvo no localStorage
    if (localStorage.getItem("contraste") === "true") {
      document.body.classList.add("contraste");
      setIsContraste(true);
    } else {
      document.body.classList.remove("contraste");
      setIsContraste(false);
    }
  }, []);

  const toggleContraste = () => {
    setIsContraste((prev) => {
      const next = !prev;
      if (next) {
        document.body.classList.add("contraste");
        localStorage.setItem("contraste", "true");
      } else {
        document.body.classList.remove("contraste");
        localStorage.setItem("contraste", "false");
      }
      return next;
    });
  };

  return { isContraste, toggleContraste };
};

export default useContraste;
